export const dataSourceContextsSelector = ({ dataSourceContexts }) =>
  dataSourceContexts || []